import React from "react";
import "../Navigation/Footer.css";
import FooterLogo from "../../Assets/Images/white_logo.svg";
import Zoopla from "../../Assets/Images/Footer/Zoopla.png";
import OnTheMarket from "../../Assets/Images/Footer/OTM.png";
import NRLA from "../../Assets/Images/Footer/NRLA-Logo.jpg";
import PRA from "../../Assets/Images/Footer/PRA.png";
import CMP from "../../Assets/Images/Footer/CMP-logo.png";
import ICO from "../../Assets/Images/Footer/ICO.png";
import HRMC from "../../Assets/Images/Footer/HMRC.jpg";
import SpareRoom from "../../Assets/Images/Footer/spareroom.png";
import NAEA from "../../Assets/Images/Footer/NAEA.jpg";
import Email from "../../Assets/Images/Footer/Email.svg";
import RightMove from "../../Assets/Images/Footer/rightmove.jpg";

function Footer() {
  return (
    <footer className="footer">
      <div className="footerContainer">
        <a href="/" className="logoLink brand">
          <img src={FooterLogo} className="footerLogo" alt="footer logo" />
        </a>
        <ul className="footerMenu">
          <li className="footerLinks">
            <a href="/terms-and-conditions">Terms & Conditions</a>
          </li>
          <li className="footerLinks">
            <a href="/privacy-policy">Privacy Policy</a>
          </li>{" "}
          <li className="footerLinks">
            <a href="/faqs">FAQS</a>
          </li>
          <li className="footerLinks">
            <a href="/cookie-policy">Cookie policy</a>
          </li>
        </ul>
        <ul className="footerMediaIcons">
          <li className="footerMediaLinks">
            <a href="https://www.instagram.com/zenhomesldn" target="_blank">
              <i className="fab fa-instagram"></i>
            </a>
          </li>
          <li className="footerMediaLinks">
            <a href="/contact-us">
              <img src={Email} alt="email" className="emailIcon" />
            </a>
          </li>
          <li className="footerMediaLinks">
            <a href="https://www.linkedin.com/company/zen-homes-london-ltd/" target="_blank">
              <i className="fab fa-linkedin"></i>
            </a>
          </li>
        </ul>
        <div className="bottomFooter">
          <div className="leftSectionFooter">
            <p className="copyright">
              &copy; Copyright Zen Homes {new Date().getFullYear()}{" "} &nbsp;| &nbsp;
              All rights reserved &nbsp;|&nbsp; Company Registration No. 1353258 &nbsp;|&nbsp; VAT Registration No. 491837160
            </p>
            <p className="copyrightAddress">
              Registered Address: 20 Westerham Avenue, London, United Kingdom, N9 9BU
            </p>
          </div>
          <div className="rightSectionFooter">
            <a
              href="https://www.zoopla.co.uk/find-agents/branch/zen-homes-london-129858/"
              target="_blank"
            >
              <img
                src={Zoopla}
                loading="lazy"
                className="footerExternalIcon zoopla"
                alt="zoopla"
              />
            </a>
            <a
              href="https://www.onthemarket.com/agents/branch/zen-homes-london/"
              target="_blank"
            >
              <img
                src={OnTheMarket}
                loading="lazy"
                className="footerExternalIcon otm"
                alt="On The Market"
              />
            </a>
            <a
              href="https://www.rightmove.co.uk/estate-agents/agent/Zen-Homes/London-301562.html/"
              target="_blank"
            >
              <img
                src={RightMove}
                loading="lazy"
                className="footerExternalIcon otm"
                alt="Right Move"
              />
            </a>
            <a href="https://www.nrla.org.uk/" target="_blank">
              <img
                src={NRLA}
                loading="lazy"
                className="footerExternalIcon"
                alt="NRLA"
                width={70}
              />
            </a>
            <a href="https://www.propertyredress.co.uk/" target="_blank">
              <img
                src={PRA}
                loading="lazy"
                className="footerExternalIcon"
                alt="Property Redress"
              />
            </a>
            <a href="https://www.clientmoneyprotect.co.uk/" target="_blank">
              <img
                src={CMP}
                loading="lazy"
                className="footerExternalIcon cmp"
                alt="Client Money Protect"
              />
            </a>
            <a href="https://ico.org.uk/" target="_blank">
              <img
                src={ICO}
                loading="lazy"
                className="footerExternalIcon"
                alt="Information Commissioner's Office"
              />
            </a>
            <a
              href="https://www.gov.uk/anti-money-laundering-registration"
              target="_blank"
            >
              <img src={HRMC} loading="lazy" className="footerExternalIcon" />
            </a>
            <a href="">
              <img
                src={SpareRoom}
                loading="lazy"
                className="footerExternalIcon spareroom"
                alt="Anti-Money Laundering"
              />
            </a>
            <a href="https://www.propertymark.co.uk/" target="_blank">
              <img
                src={NAEA}
                loading="lazy"
                className="footerExternalIcon naea"
                alt="NAEA"
              />
            </a>
          </div>
          <div className="smallText">
            <p className="smallTextContent">
              Website Designed & Built by <a href="https://www.estherboateng.co.uk/" target="_blank">Esther Boateng</a>
            </p>
          </div>

          <div className="agentIcons"></div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
